import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { useIsStaff } from "./auth.roles";

/**
 * StaffOnly renders its children for moderators, admins and super admins and
 * sends everyone else back to the chat, so a hidden page stays unreachable by
 * typing its URL.
 */
export function StaffOnly({ children }: { children: ReactNode }) {
  const isStaff = useIsStaff();

  if (!isStaff) {
    return <Navigate to="/chat" replace />;
  }

  return children;
}
